import ReactDOM from 'react-dom/client';
import { AppContextProvider } from './context/auth-provider';
import { ToastContainer } from 'react-toastify';
import AlertDialogContainerComponent from './components/common/dialog-boxes/alert-dialog';
import ConfirmDialogContainerComponent from './components/common/dialog-boxes/confirm-dialog';
import AppRouter from './router/app-router';
import { PageLoaderComponent } from './components/common/page-loader';
import { generateAppThemeProps, Theme1Colors } from './utils/theme';

import './style.scss';
import { CommonHelper } from './utils/common-helper';

export const applyTheme = () => {
    const colors = Theme1Colors;
    const root = document.documentElement;
    generateAppThemeProps(colors).forEach(({ name, value }) => {
        root.style.setProperty(name, value);
    });
};

applyTheme();

if (CommonHelper.environment.isProduction()) {
    const version = CommonHelper.environment.getVersion();
    const buildTimestamp = CommonHelper.environment.getBuildDate();
    console.log(`%c${version} at ${buildTimestamp}`, "color:yellow");
}

// Targeting the root element in the HTML
const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
root.render(
    <>
        <AppContextProvider>
            <AppRouter />
        </AppContextProvider>

        <ToastContainer />
        <PageLoaderComponent />
        <AlertDialogContainerComponent />
        <ConfirmDialogContainerComponent />
    </>
);
